import {BaseEntity} from "./BaseEntity";

export class MaintenanceHistory implements BaseEntity {
    constructor(public id?: number,
        public assetID?: number,
        public whenPerformed?: string,
        public actionPerformed?: string,
        public notes?: string,
        public performedBy?: string,
        public regularMaintenance?: boolean) {
        if(whenPerformed == null){
            var currentDate = new Date()
            var day = currentDate.getDate()
            var month = currentDate.getMonth() + 1
            var year = currentDate.getFullYear()
            this.whenPerformed =  year + "-" + month + "-" + day;
        }

    }
    parseJson(json: any): void {
        this.id = json.id;
        this.assetID = json.assetID;
        this.whenPerformed = json.whenPerformed;
        this.actionPerformed = json.actionPerformed;
        this.notes = json.notes;
        this.performedBy = json.performedBy;
        this.regularMaintenance = json.regularMaintenance;
    }
}
